import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface IComponentDescriptionSystemKindProps {
  kind: number;
}

const useStylesAccountingAnalysis = makeStyles({
  root: {
    borderColor: '#006699',
    color: '#006699',
    marginRight: '20px',
  },
});

const useStylesFinancialAccounts = makeStyles({
  root: {
    borderColor: '#669933',
    color: '#669933',
    marginRight: '20px',
  },
});

const useStylesCostAnalysis = makeStyles({
  root: {
    borderColor: '#FF530D',
    color: '#FF530D',
    marginRight: '20px',
  },
});

const useStylesHumanResources = makeStyles({
  root: {
    borderColor: '#9400D3',
    color: '#9400D3',
    marginRight: '20px',
  },
});

const useStylesDefault = makeStyles({
  root: {
    borderColor: '#505050',
    color: '#505050',
    marginRight: '20px',
  },
});

const ComponentDescriptionSystemKind: React.FC<IComponentDescriptionSystemKindProps> = ({ kind }) => {
  const accountingAnalysis = 'Accounting Analysis';
  const financialAccounts = 'Financial Accounts';
  const costAnalysis = 'Reports BI';
  const humanResources = 'Human Resources';
  const kind_dimensoes = 'Dimensões';
  const kind_comercial = 'Comercial';
  const kind_financeiro = 'Financeiro';
  const kind_suprimentos = 'Suprimentos';
  const kind_estoque = 'Estoque';
  const kind_frete = 'Frete';
  const kind_manofatura = 'Manofatura';
  const kind_controladoria = 'Controladoria';

  const cssAccountingAnalysis = useStylesAccountingAnalysis();
  const cssFinancialAccounts = useStylesFinancialAccounts();
  const cssCostAnalysis = useStylesCostAnalysis();
  const cssHumanResources = useStylesHumanResources();
  const cssDefault = useStylesDefault();

  return (
    <div style={{
      width: '100%',
      display: 'flex',
    }}>

      {(kind & 1) > 0 && (
        <span className={cssAccountingAnalysis.root}>{accountingAnalysis}</span>
      )}

      {(kind & 2) > 0 && (
        <span className={cssFinancialAccounts.root}>{financialAccounts}</span>
      )}

      {(kind & 4) > 0 && (
        <span className={cssCostAnalysis.root}>{costAnalysis}</span>
      )}

      {(kind & 8) > 0 && (
        <span className={cssHumanResources.root}>{humanResources}</span>
      )}

      {(kind & 16) > 0 && (
        <span className={cssDefault.root}>{kind_dimensoes}</span>
      )}

      {(kind & 32) > 0 && (
        <span className={cssDefault.root}>{kind_comercial}</span>
      )}

      {(kind & 64) > 0 && (
        <span className={cssDefault.root}>{kind_financeiro}</span>
      )}

      {(kind & 128) > 0 && (
        <span className={cssDefault.root}>{kind_suprimentos}</span>
      )}

      {(kind & 256) > 0 && (
        <span className={cssDefault.root}>{kind_estoque}</span>
      )}

      {(kind & 512) > 0 && (
        <span className={cssDefault.root}>{kind_frete}</span>
      )}

      {(kind & 1024) > 0 && (
        <span className={cssDefault.root}>{kind_manofatura}</span>
      )}

      {(kind & 2048) > 0 && (
        <span className={cssDefault.root}>{kind_controladoria}</span>
      )}


      {/* {(kind & 1) > 0 && (
        <ContainerChip>
          <Chip label={accountingAnalysis} variant="outlined" className={cssAccountingAnalysis.root} />
        </ContainerChip>
      )}

      {(kind & 2) > 0 && (
        <ContainerChip>
          <Chip label={financialAccounts} variant="outlined" className={cssFinancialAccounts.root} />
        </ContainerChip>
      )}

      {(kind & 4) > 0 && (
        <ContainerChip>
          <Chip label={costAnalysis} variant="outlined" className={cssCostAnalysis.root} />
        </ContainerChip>
      )}

      {(kind & 8) > 0 && (
        <ContainerChip>
          <Chip label={humanResources} variant="outlined" className={cssHumanResources.root} />
        </ContainerChip>
      )}

      {(kind & 16) > 0 && (
        <ContainerChip>
          <Chip label={kind_dimensoes} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 32) > 0 && (
        <ContainerChip>
          <Chip label={kind_comercial} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 64) > 0 && (
        <ContainerChip>
          <Chip label={kind_financeiro} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 128) > 0 && (
        <ContainerChip>
          <Chip label={kind_suprimentos} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 256) > 0 && (
        <ContainerChip>
          <Chip label={kind_estoque} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 512) > 0 && (
        <ContainerChip>
          <Chip label={kind_frete} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 1024) > 0 && (
        <ContainerChip>
          <Chip label={kind_manofatura} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )}

      {(kind & 2048) > 0 && (
        <ContainerChip>
          <Chip label={kind_controladoria} variant="outlined" className={cssDefault.root} />
        </ContainerChip>
      )} */}
    </div>
  );
};

export default ComponentDescriptionSystemKind;
